import React, { useEffect, useState } from "react";
import axios from "axios";
import { host } from "../../api/ApiCalls";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminWithdrawRequests = ({
  component,
  setComponent,
  requests,
  setRequests,
  fetchWithdrawRequests,
}) => {
  const [withdrawActionLoadingIndex, setWithdrawActionLoadingIndex] =
    useState(null);
  const [approvingIndex, setApprovingIndex] = useState(null);
  const [rejectingIndex, setRejectingIndex] = useState(null);

  //   const [requests, setRequests] = useState([]);
  const navigate = useNavigate();

  //   useEffect(() => {
  //     fetchWithdrawRequests();
  //   }, []);

  //   const fetchWithdrawRequests = async () => {
  //     try {
  //       const token = JSON.parse(localStorage.getItem("academiaHubToken"));
  //       const res = await axios.get(`${host}/api/admin/withdraw-requests`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setRequests(res.data.requests);
  //     } catch (err) {
  //       toast.error("Failed to load withdraw requests.");
  //     }
  //   };

  const handleStatusUpdate = async (teacherId, requestIndex, newStatus) => {
    // setWithdrawActionLoadingIndex(requestIndex); // set loading for current row
    if (newStatus === "approved") setApprovingIndex(requestIndex);
    if (newStatus === "rejected") setRejectingIndex(requestIndex);
    try {
      const token = JSON.parse(localStorage.getItem("academiaHubToken"));
      const res = await axios.post(
        `${host}/api/admin/update-withdraw-status`,
        {
          teacherId,
          requestIndex,
          newStatus,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        toast.success(res.data.message);
        fetchWithdrawRequests();
      }
      if (newStatus === "approved") setApprovingIndex(null);
      if (newStatus === "rejected") setRejectingIndex(null);
    } catch (err) {
      toast.error("Status update failed.");
      if (newStatus === "approved") setApprovingIndex(null);
      if (newStatus === "rejected") setRejectingIndex(null);
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      {/* Back Arrow */}
      <div
        className="flex items-center mb-6 cursor-pointer"
        onClick={() => setComponent("AdminDashboard")}
      >
        <svg
          className="w-6 h-6 mr-2 text-gray-600 hover:text-indigo-600 transition"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        <h2 className="text-xl font-semibold">Withdrawal Requests</h2>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="w-full text-sm text-left">
          <thead className="bg-indigo-50">
            <tr>
              <th className="px-6 py-3">Teacher</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Amount</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Requested At</th>
              <th className="px-6 py-3">Bank Details</th> {/* New column */}
              <th className="px-6 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No withdrawal requests found.
                </td>
              </tr>
            ) : (
              requests.map((teacher) =>
                teacher.withdrawRequests.map((req, index) => (
                  <tr key={`${teacher._id}-${index}`} className="border-t">
                    <td className="px-6 py-4 font-medium text-gray-800">
                      {teacher.name}
                    </td>
                    <td className="px-6 py-4 text-gray-600">{teacher.email}</td>
                    <td className="px-6 py-4">${req.amount}</td>
                    <td className="px-6 py-4 capitalize">{req.status}</td>
                    <td className="px-6 py-4">
                      {new Date(req.requestedAt).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
  <div><strong>Name:</strong> {teacher.bankDetails?.accountHolderName || "N/A"}</div>
  <div><strong>Bank:</strong> {teacher.bankDetails?.bankName || "N/A"}</div>
  <div><strong>Acc#:</strong> {teacher.bankDetails?.accountNumber || "N/A"}</div>
  <div><strong>IFSC:</strong> {teacher.bankDetails?.ifscCode || "N/A"}</div>
</td>
                    <td className="px-6 py-4 space-x-2">
                      {req.status === "pending" && (
                        <>
                          <button
                            onClick={() =>
                              handleStatusUpdate(teacher._id, index, "approved")
                            }
                            className="bg-green-500 text-white px-3 py-1 mb-1 rounded hover:bg-green-600 disabled:opacity-50"
                            disabled={approvingIndex === index}
                          >
                            {approvingIndex === index ? (
                              <div className="flex items-center justify-center gap-1">
                                <svg
                                  className="animate-spin h-4 w-4 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                                  ></path>
                                </svg>
                                Approving...
                              </div>
                            ) : (
                              "Approve"
                            )}
                          </button>
                          <button
                            onClick={() =>
                              handleStatusUpdate(teacher._id, index, "rejected")
                            }
                            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 disabled:opacity-50"
                            disabled={rejectingIndex === index}
                          >
                            {rejectingIndex === index ? (
                              <div className="flex items-center justify-center gap-1">
                                <svg
                                  className="animate-spin h-4 w-4 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                                  ></path>
                                </svg>
                                Rejecting...
                              </div>
                            ) : (
                              "Reject"
                            )}
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminWithdrawRequests;
